/*@ngInject*/
const SaveFilterAsModalController = function ($rootScope, $scope, filters, localization, coreConstant) {

    localization.getTranslations().then(function (translations) {

        $scope.title = _.get(translations, 'advancedFilter.saveFilterAs.title');
        $scope.saveButton = _.get(translations, 'advancedFilter.saveFilterAs.saveAsButton');
        $scope.cancelButton = _.get(translations, 'advancedFilter.saveFilterAs.cancelButton');

        $scope.viewModel = {
            filterName: ''
        };

        $scope.canEnableConfirmButton = function () {
            return $scope.viewModel.filterName.length > 0 && $scope.isFilterNameAvailable();
        };

        $scope.onConfirm = function () {
            $scope.$close({
                filterName: $scope.viewModel.filterName
            });
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

        $scope.isFilterNameAvailable = function () {
            let isAvailable = true;
            _.each(filters, function (filter) {
                if ($scope.viewModel.filterName === filter.name) {
                    isAvailable = false;
                }
            });
            return isAvailable;
        };
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('saveFilterAsModalController', SaveFilterAsModalController);
